'use strict';

var _regeneratorRuntime = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var configure = require('../lib/configure.js');

var toUrlSearchParams = require('../lib/to-url-search-params.js');

var createSet = configure.configure(function (api) {
  var set = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, value) {
      var options,
          params,
          res,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};

              if (!(typeof key !== 'string')) {
                _context.next = 3;
                break;
              }

              throw new Error('Invalid key type');

            case 3:
              params = _objectSpread(_objectSpread({}, options), encodeParam(key, value));
              _context.next = 6;
              return api.post('config', {
                signal: options.signal,
                searchParams: toUrlSearchParams.toUrlSearchParams(params),
                headers: options.headers
              });

            case 6:
              res = _context.sent;
              _context.next = 9;
              return res.text();

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function set(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return set;
});

var encodeParam = function encodeParam(key, value) {
  switch (typeof value) {
    case 'boolean':
      return {
        arg: [key, value.toString()],
        bool: true
      };

    case 'string':
      return {
        arg: [key, value]
      };

    default:
      return {
        arg: [key, JSON.stringify(value)],
        json: true
      };
  }
};

exports.createSet = createSet;